module.exports = __webpack_public_path__ + "img/sticker-danger.efd977a6.svg";